<template>
  <div id="ClientView" class="box">
    <div class="box-tittel">      
        <h1 class="text-center">{{this.tittle}}</h1>      
    </div>
    <div class="box-100" style>
      <ClientListComponent :clientList="$store.getters.getClients" />
    </div>
    <!--div class="box-form">
      <ClientFormComponent
        :client="$store.getters.getClientSelected"
        :update="$store.getters.getIsUpdate"
      />
    </div-->
  </div>
</template>
<script >
import ClientListComponent from "./../components/clients/ClientList.vue";
import ClientFormComponent from "./../components/clients/ClientForm.vue";


export default {
  name: "Clients",
  components: {
    ClientListComponent,
    ClientFormComponent
  },
  data() {
    return {
      tittle: "Clientes"
    };
  },  
};
</script>
<style>
#·ClientView {
  /*display: flex;*/
  /*background-color: #49a1a1;*/
  min-height: 100vh;
  width: 100%;
  height: 100%;
}
</style>